export const getMoneyFormatter = (locale: string, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale, {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  ...options,
});

export const getPercentageFormatter = (locale: string, decimalDigits: number) => new Intl.NumberFormat(locale, {
  style: "percent",
  maximumFractionDigits: decimalDigits
});

export const getNumberFormatter = (locale: string, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale, options);

export const formatUrl = (url: string) => {
  const withScheme = url.includes("://") ? url : `https://${url}`;

  try {
    const parsedUrl = new URL(withScheme);

    return parsedUrl.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
